package com.anjuros.website.redesign.sections.blog

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdBreadcrumb
import com.anjuros.website.redesign.components.RdLede
import com.anjuros.website.redesign.components.RdLink
import com.anjuros.website.redesign.components.RdPicture
import com.anjuros.website.redesign.components.RdSection
import com.anjuros.website.redesign.components.RdTag
import com.anjuros.website.redesign.styles.BlogLatestBodyStyle
import com.anjuros.website.redesign.styles.BlogLatestFigureStyle
import com.anjuros.website.redesign.styles.BlogLatestStyle
import com.anjuros.website.redesign.styles.BlogReadStyle
import com.anjuros.website.redesign.styles.BlogTopicsStyle
import com.anjuros.website.redesign.styles.RdArrowStyle
import com.anjuros.website.redesign.styles.RdHeroCopyStyle
import com.anjuros.website.redesign.styles.RdHeroGridStyle
import com.anjuros.website.redesign.styles.RdHeroStyle
import com.anjuros.website.redesign.styles.RdMarkStyle
import com.anjuros.website.redesign.styles.RdPillStyle
import com.anjuros.website.redesign.styles.RdSubpageTitleStyle
import com.anjuros.website.redesign.util.RdText
import com.anjuros.website.redesign.util.rdList
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Ul

/** Title, intro and topics, with the most recent article as a large card. */
@Composable
fun BlogHeroSection() {
    val topicsLabel = LocalText(RdText.BLOG_TOPICS_LABEL)
    RdSection(labelledBy = "h1", modifier = RdHeroStyle.toModifier(), wrapModifier = RdHeroGridStyle.toModifier()) {
        Div(RdHeroCopyStyle.toModifier().toAttrs()) {
            RdBreadcrumb(RdText.BLOG_CRUMB)
            H1(RdSubpageTitleStyle.toModifier().id("h1").toAttrs()) {
                Text(LocalText(RdText.BLOG_HERO_TITLE_START))
                Span(RdMarkStyle.toModifier().toAttrs()) { Text(LocalText(RdText.BLOG_HERO_TITLE_MARK)) }
            }
            RdLede(RdText.BLOG_HERO_LEDE)
            Ul(BlogTopicsStyle.toModifier().attrsModifier { attr("aria-label", topicsLabel) }.toAttrs()) {
                rdList(LocalText(RdText.BLOG_TOPICS)).forEach { Li { Text(it) } }
            }
        }
        LatestGuideCard(LatestBlogGuide)
    }
}

@Composable
private fun LatestGuideCard(guide: RdBlogGuide) {
    RdLink(guide.card.pathToArticle, BlogLatestStyle.toModifier()) {
        RdTag("figure", BlogLatestFigureStyle.toModifier()) {
            RdPicture(guide.image, LocalText(guide.imageAlt), lazy = false)
            Span(RdPillStyle.toModifier().toAttrs()) { Text(LocalText(RdText.BLOG_LATEST)) }
        }
        Div(BlogLatestBodyStyle.toModifier().toAttrs()) {
            BlogMeta(guide, showTopic = false)
            H2 { Text(LocalText(guide.card.title)) }
            P { Text(LocalText(guide.card.beginningDisplayText)) }
            Span(BlogReadStyle.toModifier().toAttrs()) {
                Text(LocalText(RdText.BLOG_LATEST_READ) + " ")
                Span(RdArrowStyle.toModifier().attrsModifier { attr("aria-hidden", "true") }.toAttrs()) { Text("→") }
            }
        }
    }
}
